/**
 * Zonas donde opera una empresa, por estado y municipio del catálogo de CP (`estaEnZonaCobertura`). Los nombres van
 * como se escriben (con acentos y mayúsculas): la comparación los normaliza (`normalizarTexto`).
 */
export interface ZonaCobertura {
  /** Estados que cuentan completos. */
  estados: string[];
  /** De los demás estados, los municipios que sí entran. */
  municipiosPorEstado: Record<string, string[]>;
}

/** Municipios conurbados del Estado de México en la Zona Metropolitana del Valle de México (CONAPO). */
const MUNICIPIOS_ZMVM_ESTADO_DE_MEXICO = [
  "Acolman",
  "Amecameca",
  "Apaxco",
  "Atenco",
  "Atizapán de Zaragoza",
  "Atlautla",
  "Axapusco",
  "Ayapango",
  "Coacalco de Berriozábal",
  "Cocotitlán",
  "Coyotepec",
  "Cuautitlán",
  "Cuautitlán Izcalli",
  "Chalco",
  "Chiautla",
  "Chicoloapan",
  "Chiconcuac",
  "Chimalhuacán",
  "Ecatepec de Morelos",
  "Ecatzingo",
  "Huehuetoca",
  "Hueypoxtla",
  "Huixquilucan",
  "Isidro Fabela",
  "Ixtapaluca",
  "Jaltenco",
  "Jilotzingo",
  "Juchitepec",
  "La Paz",
  "Melchor Ocampo",
  "Naucalpan de Juárez",
  "Nextlalpan",
  "Nezahualcóyotl",
  "Nicolás Romero",
  "Nopaltepec",
  "Otumba",
  "Ozumba",
  "Papalotla",
  "San Martín de las Pirámides",
  "Tecámac",
  "Temamatla",
  "Temascalapa",
  "Tenango del Aire",
  "Teoloyucan",
  "Teotihuacán",
  "Tepetlaoxtoc",
  "Tepetlixpa",
  "Tepotzotlán",
  "Tequixquiac",
  "Texcoco",
  "Tezoyuca",
  "Tlalmanalco",
  "Tlalnepantla de Baz",
  "Tonanitla",
  "Tultepec",
  "Tultitlán",
  "Valle de Chalco Solidaridad",
  "Villa del Carbón",
  "Zumpango",
];

/**
 * WuWei solo opera en el Valle de México (reglas del prototipo: "CDMX y municipios conurbados"): la Ciudad de México
 * completa, los municipios conurbados del Estado de México y Tizayuca (Hidalgo). El Estado de México aparece en el
 * catálogo de CP como "México" o "Estado de México".
 */
export const ZONA_COBERTURA_WUWEI: ZonaCobertura = {
  estados: ["Ciudad de México", "Distrito Federal"],
  municipiosPorEstado: {
    México: MUNICIPIOS_ZMVM_ESTADO_DE_MEXICO,
    "Estado de México": MUNICIPIOS_ZMVM_ESTADO_DE_MEXICO,
    Hidalgo: ["Tizayuca"],
  },
};
